import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';
import { IminiEpg, miniEpgData } from '../../interfaces/StoreTypes';
import { IEntitlementService } from '@intigral/domain/lib/application/services/EntitlementService';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import user from '../../helpers/user';
import h, { getCountry } from '../../helpers/common';

type MiniEpgInitializeParams = {
    type: string;
    payload: miniEpgData;
};

type FetchUserEpgChannelSucess = {
    type: string;
    payload: any[];
};

export const fetchUserProfileMiniEPGChannelsList = createAsyncThunk(
    'fetch/userProfileMiniEpg',
    async (payload: any) => {
        const { miniEpgDataParams } = payload;
        const searchParams = {
            ...miniEpgDataParams,
            country: getCountry(),
            device: h.getDevice(),
        };
        if (user.getProfileMode() === 'kid') {
            searchParams['categoryType'] = 'kids';
        }
        const entitlementService = container.resolve<IEntitlementService>(DI.SERVICES.IEntitlementService);
        const userProfileMiniEpgChannelslist = await entitlementService.getProfileMiniEpgChannels(
            user.getAPIKey(),
            user.getUsername(),
            user.getProfileName(),
            searchParams,
            user.getUserToken()
        );
        return userProfileMiniEpgChannelslist;
    }
);

const miniEpgSlice = createSlice({
    name: 'MiniEpg',
    initialState: initialState.miniEpg,
    reducers: {
        miniEpgInitialize: (state: IminiEpg, action: MiniEpgInitializeParams) => {
            state.data = action.payload;
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchUserProfileMiniEPGChannelsList.pending, (state: IminiEpg) => {
            state.isLoading = true;
            state.errMess = null;
            state.userProfileChannels = [];
        });
        builder.addCase(
            fetchUserProfileMiniEPGChannelsList.fulfilled,
            (state: IminiEpg, action: FetchUserEpgChannelSucess) => {
                state.userProfileChannels = action.payload;
                state.isLoading = false;
            }
        );
        builder.addCase(fetchUserProfileMiniEPGChannelsList.rejected, (state: IminiEpg, action: any) => {
            state.errMess = action.error.message;
            state.isLoading = false;
        });
    },
});
export const { miniEpgInitialize } = miniEpgSlice.actions;

export default miniEpgSlice.reducer;
